// Where a validated NL intent actually goes. Shared by the voice agent and the
// map popup so there is one table, not two — and so the /api routes the backend
// really serves stay in one place. Notably there is no /api/rtl: RTL is a mode
// change, and a second copy of this table is exactly how that gets forgotten.
const ENDPOINTS = {
    arm: (i) => ['/arm', { droneId: i?.droneId }],
    disarm: (i) => ['/disarm', { droneId: i?.droneId }],
    takeoff: (i) => ['/takeoff', { droneId: i?.droneId, altitude: i?.altitude, alt: i?.altitude }],
    land: (i) => ['/land', { droneId: i?.droneId }],
    rtl: (i) => ['/mode', { droneId: i?.droneId, mode: 'RTL' }],
    mode: (i) => ['/mode', { droneId: i?.droneId, mode: i?.mode }],
    goto: (i) => ['/goto', { droneId: i?.droneId, lat: i?.lat, lon: i?.lon, altitude: i?.altitude, alt: i?.altitude }],
    hold: (i) => ['/mode', { droneId: i?.droneId, mode: i?.mode }],
    move: (i) => ['/goto', { droneId: i?.droneId, lat: i?.lat, lon: i?.lon, altitude: i?.altitude, alt: i?.altitude }],
    connect: (i) => ['/connect', { droneId: i?.droneId }],
    disconnect: (i) => ['/disconnect', { droneId: i?.droneId }],
    battery_reset: (i) => [`/drones/${i?.droneId}/battery/reset`, {}],
    mission_start: (i) => [`/drones/${i?.droneId}/missions/${i?.missionId}/start`, {}],
    mission_pause: (i) => [`/drones/${i?.droneId}/missions/${i?.missionId}/pause`, {}],
    mission_resume: (i) => [`/drones/${i?.droneId}/missions/${i?.missionId}/resume`, {}],
    mission_abort: (i) => [`/drones/${i?.droneId}/missions/${i?.missionId}/abort`, {}],
    mission_upload: (i) => [`/drones/${i?.droneId}/missions/${i?.missionId}/upload`, {}],
    preflight: (i) => [`/drones/${i?.droneId}/missions/${i?.missionId}/preflight`, {}],
};

/**
 * The endpoint and payload one intent sends, or null for an intent that touches
 * no vehicle (answer, clarify) or an action we do not execute.
 */
export function buildCommand(intent) {
    const build = intent && ENDPOINTS[intent.action];
    if (!build) return null;
    const [endpoint, body] = build(intent);
    return { endpoint, body };
}

export default ENDPOINTS;
